import React from 'react';

// INSTRUCCIONES PARA EL USUARIO:
// 1. Coloca tus imágenes en la carpeta: public/clients
// 2. Asegúrate de que los nombres de archivo coincidan con la lista de abajo (logo)
//    O edita la lista de abajo para que coincida con tus archivos.

const clients = [
  { id: 1, name: 'Cliente 1', logo: 'client-1.jpg' },
  { id: 2, name: 'Cliente 2', logo: 'client-2.jpg' },
  { id: 3, name: 'Cliente 3', logo: 'client-3.jpg' },
  { id: 4, name: 'Cliente 4', logo: 'client-4.jpg' },
  { id: 5, name: 'Cliente 5', logo: 'client-5.jpg' },
  { id: 6, name: 'Cliente 6', logo: 'client-6.jpg' },
  { id: 7, name: 'Cliente 7', logo: 'client-7.jpg' },
  { id: 8, name: 'Cliente 8', logo: 'client-8.jpg' },
  { id: 9, name: 'Cliente 9', logo: 'client-9.jpg' },
];

const Clients = () => {
  return (
    <div className="py-16 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10 text-center">
        <h2 className="text-base text-primary font-semibold tracking-wide uppercase">Confianza</h2>
        <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
          Nuestros Clientes
        </p>
      </div>

      {/* Static Grid Container */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center">
          {clients.map((client) => (
            <div 
              key={client.id} 
              className="flex items-center justify-center p-4 grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100"
            >
              <img 
                src={`${process.env.PUBLIC_URL}/clients/${client.logo}`} 
                alt={client.name}
                className="max-h-16 md:max-h-20 w-auto object-contain"
                onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    const span = document.createElement('span');
                    span.innerText = client.name;
                    span.className = 'text-lg font-bold text-gray-300 border-2 border-dashed border-gray-200 p-2 rounded w-full text-center';
                    e.currentTarget.parentElement?.appendChild(span);
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Clients;